import React, { useState, useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Box, RadioGroup, FormControlLabel, Radio, CircularProgress } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import PauseCircleIcon from '@mui/icons-material/PauseCircle';

import PharmaorderPageContainer from './PharmaorderPageContainer';
import PharmaorderPageCancelledAndHold from './PharmaorderPageCancelledAndHold';
import {getListAPI as getTagList} from 'components/tag/TagAPI';
import { setTagList } from 'store/slice/AppSlice';
import { getOrderWithProductsAPI } from 'api/OmsOrdermgmtWebServices';
import { orderList, setProductList, setPharmaorderList } from 'store/slice/PharmaSlice';
import { callGetAPI } from 'api/ApiUtils';


export default function PharmaorderPageRootHolder() {
    const dispatch = useDispatch();
    const [orderStatus, setOrderStatus] = useState('current'); // 'none', 'cancelled', 'onhold'
    const [selectedTagId, setSelectedTagId] = useState(0);
    const [loading, setLoading] = useState(false);
    const {tagList} = useSelector((state) => state.appslice.tagMgmt);
    const {rolename}    = useSelector((state) => state.headerslice.userprofileInfo);

    useEffect(() => {
        if (!tagList || tagList.length === 0) {
            getTagList(()=>{}, (list)=>{
                dispatch(setTagList(list)); 
            });
        }
    },[]);
    useEffect(() => {
        handleMonthTagClick(0);
    },[tagList]);

    useEffect(() => {
        loadOrdersByTagId(selectedTagId);
    },[selectedTagId]);

    const handleStatusChange = (e) => {
        setOrderStatus(e.target.value);
        setSelectedTagId(0); // Deselect tag filter when a radio is clicked
    };
    const loadOrdersByTagId = (tagId) => {
        setLoading(true);
        callGetAPI("https://api.mypharmafactory.com/extn/pharmaorders/monthtagid/"+tagId,
            ()=>{},
            (orderList)=>{
                dispatch(setPharmaorderList(orderList));
                setLoading(false);
            },
            (errorMsg)=>{
                console.error("Error fetching orders by tag:", errorMsg);
                setLoading(false);
            }
        )
    }

    const handleMonthTagClick = (tagId) => {
         if (selectedTagId === tagId) {
             setOrderStatus('current');
            setSelectedTagId(0); // Deselect if already selected
        } else {
             setOrderStatus('none'); 
            setSelectedTagId(tagId);
           
        }
    }
    

    // Memoize the main content to prevent unnecessary re-renders
    const mainContent = useMemo(() => {
        console.log("Rendering main content for orderStatus:", orderStatus);
        if (orderStatus === 'cancelled') {
            return <PharmaorderPageCancelledAndHold key="cancelled" label="Cancelled Orders" typeId='10' />;
        } else if (orderStatus === 'onhold') {
            return <PharmaorderPageCancelledAndHold key="onhold" label="Orders On Hold" typeId='9' />;
        } else if (orderStatus === 'archived') {
            return <PharmaorderPageCancelledAndHold key="archived" label="Archived Orders" typeId='8' />;
        } else 
            return <PharmaorderPageContainer key="container" orderStatus={orderStatus} />;
        
    }, [orderStatus]);

    return (
        <Grid container direction="column" sx={{ width: '100%' }}>
            {/* Top Ribbon */}
            <Grid item xs={12}>
                <Box sx={{ 
                    width: '100%',
                    backgroundColor: 'white',
                    borderRadius: 1,
                    p: 1,
                    mb: 2,
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                }}>
                    {/* Tag List at left */}
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      {tagList && tagList.length > 0 && tagList
                        .slice()
                        .sort((a, b) => (a.seq ?? 0) - (b.seq ?? 0))
                        .map(tag => (
                          <Box
                            key={tag.id}
                            sx={{
                              px: 1.5,
                              py: 0.5,
                              backgroundColor: selectedTagId === tag.id ? 'primary.darker' : 'primary.100',
                              color: selectedTagId === tag.id ? 'white' : 'primary.main',
                              borderRadius: 1,
                              fontWeight: 600,
                              fontSize: 14,
                              display:tag.visible==1?'inline':'none',
                              cursor: 'pointer',
                              '&:hover': { backgroundColor: selectedTagId === tag.id ? 'primary.darker' : 'primary.200' }
                              
                            }}
                            onClick={() => handleMonthTagClick(tag.id)}
                          >
                            {tag.title}
                          </Box>
                        ))}
                    </Box>
                    {/* Radio buttons for Cancelled and On Hold */}
                    <RadioGroup
                        row
                        value={orderStatus}
                        onChange={handleStatusChange}
                        sx={{ gap: 1 }}
                    >
                        <FormControlLabel
                            value="archived"
                            control={<Radio color="info" />}
                            label="Archived"
                        />
                        <FormControlLabel
                            value="cancelled"
                            control={<Radio color="error" />}
                            label="Cancelled"
                        />
                        <FormControlLabel
                            value="onhold"
                            control={<Radio color="warning" />}
                            label="On Hold"
                        />
                        <FormControlLabel
                            value="current"
                            control={<Radio color="default" />}
                            label="Current Orders"
                        />
                    </RadioGroup>
                </Box>
            </Grid>
            
            {/* Main Content - Memoized Rendering */}
            <Grid item xs={12}>
                {loading ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 200 }}>
                        <CircularProgress size={40} />
                        <Box sx={{ ml: 2, fontWeight: 600 }}>Loading...</Box>
                    </Box>
                ) : (
                    mainContent
                )}
            </Grid>
        </Grid>
    )
}